<template>
    <div class="groups-admin-view">
        <AdminTable class="ma-4"
                    :items="items"
                    @edit:item="onEditItem($event)"
                    create-button-text="Создать группу"
                    :get-new-item="() => null"
                    :get-headers="getHeaders"
                    :go-to-handler="goToGroup" />

        <GroupDialog v-if="showEditDialog"
                     @hide="hideEditDialog"
                     :group="editedItem"
                     edit-title="Редактирование группы"
                     create-title="Создание группы"
                     @update:group="upsertServerItem($event)" />
    </div>
</template>

<script>
    import { DateTime } from "luxon";

    import AdminTable from "@/components/admin/AdminTable.vue";
    import GroupDialog from "@/components/GroupDialog.vue";

    export default {
        components: {
            AdminTable,
            GroupDialog
        },

        data() {
            return {
                showEditDialog: false,
                editedItem: null
            };
        },

        created() {
            this.$store.dispatch("admin/loadGroups");
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            },

            items() {
                return this.$store.state.admin.groups
                    .map(e => ({
                        id: e.id,
                        guid: e.guid,
                        name: e.name,
                        description: e.description,
                        createdDate: this.getDateTime(e.createdDate),
                        creatorId: e.creator.id,
                        creatorName: e.creator.userName,
                        membersCount: e.membersCount,
                        rawItem: e
                    }));
            }
        },

        watch: {

        },

        methods: {
            goToGroup(group) {
                this.$router.push({
                    name: "groupInfoPage",
                    params: {
                        groupGuid: group.guid
                    }
                });
            },

            onEditItem(data) {
                this.showEditDialog = true;
                this.editedItem = data.editItem
                    ? data.item
                    : null;
            },

            hideEditDialog() {
                this.showEditDialog = false;
                this.editedItem = null;
            },

            upsertServerItem(group) {
                this.$store.dispatch("upsertGroup", group)
                    .then(() => {
                        this.$store.dispatch("admin/loadGroups");
                    });
            },

            getBoolString(bool) {
                return bool === true
                    ? "Да"
                    : "Нет";
            },

            getDateTime(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("yyyy.MM.dd HH:mm");
            },

            getHeaders() {
                return [
                    {
                        title: "Id",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "id"
                    },
                    {
                        title: "Название",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "name"
                    },
                    {
                        title: "Описание",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "description"
                    },
                    {
                        title: "Количество участников",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "membersCount"
                    },
                    {
                        title: "Guid",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "guid"
                    },
                    {
                        title: "Дата создания",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "createdDate"
                    },
                    {
                        title: "Id создателя",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "creatorId"
                    },
                    {
                        title: "Имя создателя",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "creatorName"
                    },
                    {
                        title: "",
                        align: "end",
                        sortable: false,
                        removable: true,
                        key: "buttons"
                    }
                ];
            }
        }
    };
</script>

<style lang="scss">
    .groups-admin-view {
    }
</style>